<template>
  <div>
    <div class="order-info">
      <div class="order-status">
        <van-icon name="passed" size="48" color="#07c160" />
        <h3>预约成功</h3>
      </div>

      <div class="order-detail">
        <ul>
          <li>
            <span class="item-text">当前状态</span>
            <span class="item-value">已预约</span>
          </li>
          <li>
            <span class="item-text">体检人员</span>
            <span class="item-value">{{userOrder.name}}</span>
          </li>
          <li v-show="false">
            <span class="item-text">联系手机</span>
            <span class="item-value">{{userOrder.mobile | mask("phone")}}</span>
          </li>
          <li>
            <span class="item-text">体检机构</span>
            <span class="item-value">{{hospInfo.name}}</span>
          </li>
          <li>
            <span class="item-text">体检地点</span>
            <span class="item-value">{{hospInfo.address}}</span>
          </li>
          <li>
            <span class="item-text">体检时间</span>
            <span class="item-value">{{userOrder.appointDate}} {{userOrder.appointTimeRangeName}}</span>
          </li>
          <li>
            <span class="item-text">体检套餐</span>
            <span class="item-value">{{userOrder.package.name}}</span>
          </li>
          <li>
            <span class="item-text">预约编号</span>
            <span class="item-value">{{userOrder.orderNo}}</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="order-action">
      <van-cell title="检前须知" is-link />
      <van-cell title="联系客服" is-link />
      <van-cell title="服务评价" is-link />
    </div> -->

    <div class="order-action">
      <van-button size="large" type="info" @click="$router.push('/')">返回</van-button>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .order-info {
    background: #fff;
    padding: 32px 24px;
    margin-bottom: 12px;
    text-align: center;

    .order-status {
      padding-bottom: 24px;
      margin-bottom: 24px;
      border-bottom: 1px solid #ebedf0;

      h3 {
        font-size: 20px;
        margin-top: 8px;
      }
    }

    .order-detail {
      text-align: left;
      font-size: 14px;

      li {
        list-style: none;
        display: flex;
        line-height: 32px;

        .item-text {
          width: 80px;
          color: #888;
        }

        .item-value {
          flex: 1;
        }
      }
    }
  }

  .order-action {
    padding: 12px;
    background: #fff;
  }
</style>

<script>
  import {
    mapState,
    mapMutations,
    mapActions
  } from "vuex";
  export default {
    name: "orderSuccess",
    data() {
      return {
        name: this.$route.params.name
      }
    },
    mounted() {
      console.log(this.$route.params);
    },
    computed: {
      userOrder() {
        return this.$route.params
      },
      ...mapState({
        hospInfo: state => state.hospital.hospInfo
      })
    },
  }
</script>